import Vue from "vue";
import { EventTrackingService } from "@/services";
import { themeHelper } from "@/components/mixins";

export default Vue.extend({
  name: "DontMissCard",
  mixins: [themeHelper],
  props: {
    link: {
      type: String,
      default: "#link"
    },
    title: {
      type: String,
      default: "Dont Miss Card"
    },
    icon: {
      type: String,
      default: "icon"
    },
  },
  computed: {
    parentTag() {
      if(this.link.startsWith('/'))
      {
        return "router-link";
      }
      else if(this.link.startsWith('http')){
        return "a"
      }
      return "div";
    },
  },
  methods: {
    clickedCard(){
      EventTrackingService.trackEvent({
        category: "ShoppingCart-ThankYouPage",
        action: "ClickedDontMissCard",
        label: this.title,
        value: this.link,
    });
    }
  }
});
